
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"10","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"rhwga","d":"M1620.653 1032.48h-6.826c.323 1.509 1.818 2.134 3.414 2.134 1.109 0 2.099-.237 2.927-.625v2.348c-.91.41-2.101.646-3.555.646-3.069 0-5.613-1.874-5.613-5.472 0-3.899 2.806-5.471 4.989-5.471 4.017 0 5.31 3.382 4.664 6.44zm-2.534-1.944c.1-.708-.282-2.21-2.036-2.21-1.19 0-2.235.794-2.277 2.21z"}}),_c('path',{attrs:{"id":"rhwgb","d":"M1618.098 1025.177c-.633 0-1.128-.483-1.128-1.081a1.11 1.11 0 011.128-1.096c.615 0 1.11.497 1.11 1.096 0 .598-.495 1.08-1.11 1.08z"}}),_c('path',{attrs:{"id":"rhwgc","d":"M1614.048 1025.177c-.616 0-1.128-.483-1.128-1.081 0-.6.512-1.096 1.128-1.096.615 0 1.113.497 1.113 1.096 0 .598-.498 1.08-1.113 1.08z"}})]),_c('use',{attrs:{"fill":"#ffdb4d","xlink:href":"#rhwga","transform":"translate(-1611 -1023)"}}),_c('use',{attrs:{"fill":"#ffdb4d","xlink:href":"#rhwgb","transform":"translate(-1611 -1023)"}}),_c('use',{attrs:{"fill":"#ffdb4d","xlink:href":"#rhwgc","transform":"translate(-1611 -1023)"}})])
          )
        }
      }
    